import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Theme } from 'styles/ThemeTyping';
import { PERMISSION_ITEMS } from 'pages/RolesAndPermissions/consts';
import * as Types from 'pages/RolesAndPermissions/typings';

import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

interface Props {
  open: boolean;
  anchorEl: null | HTMLElement;
  selectedPermissions: Types.PermissionResponse[];
  onClick: (permissionId: string) => void;
}

function AddPermissionsDropdown({ anchorEl, onClick, open, selectedPermissions }: Props) {
  const classes = useStyles();

  return (
    <Popper open={open} anchorEl={anchorEl} transition disablePortal className={classes.root}>
      <Paper>
        <MenuList className={classes.menu}>
          {PERMISSION_ITEMS.map(option => (
            <MenuItem
              key={option.id}
              onClick={() => onClick(option.id)}
              disabled={selectedPermissions.some(
                permission => permission.permissionId === option.id,
              )}
            >
              {option.name}
            </MenuItem>
          ))}
        </MenuList>
      </Paper>
    </Popper>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: 377,
  },
  menu: {
    overflowY: 'auto',
  },
}));

export default AddPermissionsDropdown;
